var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsCloudFormation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_77)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 76H180V176H80V76Z",
    fill: "url(#paint0_linear_1_77)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.5 125.955H155V123.45H147.5V125.955ZM115 140.978H122.5V138.473H115V140.978ZM102.5 140.978H110V138.473H102.5V140.978ZM102.5 133.465H117.5V130.963H102.5V133.465ZM102.5 118.443H115V115.94H102.5V118.443ZM102.5 125.955H142.5V123.45H102.5V125.955ZM127.42 153.495H97.5V110.933H127.42V118.485H129.92V109.68C129.92 109.348 129.788 109.031 129.554 108.796C129.319 108.562 129.002 108.43 128.67 108.43H96.25C95.9185 108.43 95.6005 108.562 95.3661 108.796C95.1317 109.031 95 109.348 95 109.68V154.75C94.9997 154.914 95.0318 155.077 95.0944 155.229C95.1571 155.381 95.2491 155.519 95.3652 155.636C95.4813 155.752 95.6192 155.844 95.7711 155.907C95.9229 155.97 96.0856 156.003 96.25 156.003H128.67C129.002 156.003 129.319 155.871 129.554 155.636C129.788 155.402 129.92 155.084 129.92 154.753V131.008H127.42V153.498V153.495ZM165 122.2C165 133.338 155.1 133.465 155 133.465H135V130.963H155C155.763 130.955 162.5 130.658 162.5 122.2C162.5 115.08 156.078 113.638 154.793 113.418C154.483 113.365 154.205 113.199 154.013 112.951C153.821 112.703 153.729 112.392 153.755 112.08L153.763 112.005C153.69 107.988 151.225 106.73 150.158 106.38C148.16 105.71 145.94 106.35 144.763 107.925C144.627 108.106 144.445 108.247 144.236 108.332C144.027 108.418 143.799 108.446 143.576 108.412C143.353 108.378 143.142 108.285 142.968 108.142C142.794 107.998 142.661 107.81 142.585 107.598C141.808 105.423 140.68 104.013 139.115 102.443C135.193 98.545 129.888 97.475 124.908 99.5675C122.298 100.668 120.018 103.163 118.653 106.41L116.348 105.44C117.963 101.593 120.73 98.6125 123.938 97.26C129.885 94.755 136.215 96.0325 140.88 100.67C142.215 102.01 143.325 103.313 144.188 105.005C146.06 103.625 148.568 103.213 150.948 104C153.988 105.013 155.91 107.653 156.22 111.163C160.475 112.238 165 115.643 165 122.2Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_77",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_77"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_77",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_77",
    x1: 80,
    y1: 10076,
    x2: 10080,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloudFormation);
export default __webpack_public_path__ + "static/media/aws-cloud-formation.c714eb31331390b1179a18964deee0d0.svg";
export { ForwardRef as ReactComponent };